import template from './vd-upsell-primary.html'
import controller from './vd-upsell-primary.controller'

export default {
  bindings: {
    header: '<',
    body: '<',
  },
  transclude: {
    action: 'vdUpsellAction',
    image: 'vdUpsellImage',
    promoBlock1: 'vdUpsellPromoBlock1',
    promoBlock2: 'vdUpsellPromoBlock2',
    promoBlock3: 'vdUpsellPromoBlock3',
  },
  template,
  controller,
}
